(() => {
  // app/scripts/documents-search.js
  var DocumentsSearch = class extends HTMLElement {
    constructor() {
      super();
      this.type = this.dataset.type.split("-").join("_");
      this.search_catalog = this.querySelector(".search_catalog");
      this.search_lot = this.querySelector(".search_lot");
      this.button = this.querySelector("button");
      this.mobile = this.dataset.mobile;
    }
    connectedCallback() {
      this.button.addEventListener("click", () => {
        if (["certificate_of_analysis", "certificate_of_origin"].includes(this.type)) {
          this.getCertificates();
        } else {
          this.getProductMetaFields();
        }
      });
    }
    async getProductMetaFields() {
      const search_catalog = this.search_catalog.value.trim();
      try {
        if (!search_catalog)
          throw "Search value is blank";
        const response = await fetch(window.Shopify.routes.root + `products/${search_catalog}`);
        if (!response.ok)
          throw response.status;
        const html = document.createElement("div");
        html.innerHTML = await response.text();
        const result = html.querySelector("#product-metafields-data");
        const resultEl = JSON.parse(result.textContent);
        if (resultEl.catalog_number == search_catalog) {
          this.open(resultEl[this.type]);
        } else {
          this.activeError();
        }
      } catch (error) {
        this.activeError();
        console.log("error :>> ", error);
      }
    }
    async getCertificates() {
      const search_catalog = this.search_catalog.value.trim();
      const search_lot = this.search_lot.value.trim();
      const fileUrl = this.type === "certificate_of_origin"
        ? window.theme?.settings?.certificateOfOriginUrl
        : window.theme?.settings?.certificateOfAnalysisUrl;
      const res = await fetch(fileUrl || `https://cdn.shopify.com/s/files/1/0622/1676/5596/files/${this.type}.json`);
      const data = await res.json();
      const result = await data.find((i) => i?.lot_no == search_lot && i?.cat_no == search_catalog);
      if (result) {
        this.open(result.url);
      } else {
        this.activeError();
      }
    }
    open(url) {
      this.deactiveError();
      if (this.mobile == "mobile" || this.mobile == "true") {
        setTimeout(() => {
          window.open(`${url}`, "_blank").focus();
        });
      } else {
        window.open(`${url}`, "_blank", "height=800,width=1400");
      }
    }
    activeError() {
      this.querySelector(".error-text").classList.add("active");
    }
    deactiveError() {
      this.querySelector(".error-text").classList.remove("active");
    }
  };
  !customElements.get("documents-search-form") && customElements.define("documents-search-form", DocumentsSearch);
  var documentsSearch = document.querySelector(".documents-search");
  documentsSearch.querySelectorAll(".block-content").forEach((block) => {
    block.querySelector(".block-title").addEventListener("click", () => {
      block.querySelector(".block-form")?.classList.toggle("active");
    });
  });
  var DSMegaMenu = document.querySelectorAll('[data-document-search-mega-menu="true"]');
  DSMegaMenu.forEach(
    (menu) => menu.addEventListener("click", () => {
      window.onhashchange = function() {
        location.reload(true);
      };
    })
  );
})();